import TextureCodecBaseKtx from "@webgl/assets/TextureCodecBaseKtx";
export default class TextureCodecDxt extends TextureCodecBaseKtx {
    constructor() {
        super(...arguments);
        this.name = 'dxt';
    }
    isSupported(extensions) {
        return extensions.dxt != null;
    }
}
